module.exports = __webpack_public_path__ + "img/pha-logo-white.c92640ab.png";